export default __webpack_public_path__ + "static/media/Continent.81d6cb85.png";